/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

// const hostName to store the host name
export const hostName = window.location.hostname;

// const Tour object to store step meta data
export const Tour = {
  welcomeStep:
    createStepMetaData(
      'welcomeStep',
      'resources/images/bulb-tour-main-bulb-logo.gif',
      'onboarding_tour_get_started_body',
      `https://${hostName}/u/onboarding-tour`,
      'onboarding_tour_get_started_link_text',
      false,
      'onboarding_tour_get_started_additional_text',
    ),

  createPageStep:
    createStepMetaData(
      'createPageStep',
      null,
      'onboarding_tour_create_page_body',
      `https://${hostName}/u/pages~32`,
      'onboarding_tour_create_page_link_text',
      true,
    ),

  createCollectionStep:
    createStepMetaData(
      'createCollectionStep',
      null,
      'onboarding_tour_create_collection_body',
      `https://${hostName}/u/collections~54`,
      'onboarding_tour_create_collection_link_text',
      true,
    ),

  assetLibraryStep:
    createStepMetaData(
      'assetLibraryStep',
      null,
      'onboarding_tour_asset_library_body',
      'https://help.bulbapp.com/hc/en-us/sections/360001565054-Asset-Library',
      'onboarding_tour_asset_library_link_text',
      true,
    ),

  groupStep:
    createStepMetaData(
      'groupStep',
      null,
      'onboarding_tour_group_body',
      `https://${hostName}/u/groups~34`,
      'onboarding_tour_group_link_text',
      true,
    ),

  pageEditStep:
    createStepMetaData(
      'pageEditStep',
      'resources/images/bulb-tour-page-intro-edit.gif',
      '',
      'https://help.bulbapp.com/hc/en-us/articles/115004896788-How-to-format-Text',
      'onboarding_tour_page_intro1_link_text',
      true,
    ),

  pageEditMobileStep:
    createStepMetaData(
      'pageEditStep',
      'resources/images/bulb-tour-page-intro-edit-mobile.gif',
      '',
      'https://help.bulbapp.com/hc/en-us/articles/115004896788-How-to-format-Text',
      'onboarding_tour_page_intro1_link_text',
      true,
    ),

  pageMediaStep:
    createStepMetaData(
      'pageMediaStep',
      'resources/images/bulb-tour-page-intro-add-media.gif',
      '',
      'https://help.bulbapp.com/hc/en-us/articles/115004896988-How-to-add-a-Video',
      'onboarding_tour_page_intro2_link_text',
      true,
    ),

  pageMediaMobileStep:
    createStepMetaData(
      'pageMediaStep',
      'resources/images/bulb-tour-page-intro-add-media-mobile.gif',
      '',
      'https://help.bulbapp.com/hc/en-us/articles/115004896988-How-to-add-a-Video',
      'onboarding_tour_page_intro2_link_text',
      true,
    ),

  pageEditStepCKE:
    createStepMetaData(
      'pageEditStepCKE',
      null,
      'onboarding_tour_cke_bodytext',
      null,
      null,
      true,
    ),

  shareStep:
    createStepMetaData(
      'shareStep',
      null,
      'onboarding_tour_share_body',
      `https://${hostName}/u/sharing~7`,
      'onboarding_tour_share_link_text',
      true,
    ),

  commentsStep:
    createStepMetaData(
      'commentsStep',
      null,
      'onboarding_tour_comment_body',
      `https://${hostName}/u/commenting~6`,
      'onboarding_tour_comment_link_text',
      true,
    ),

  doneStep:
    createStepMetaData(
      'doneStep',
      'resources/images/bulb-tour-end.gif',
      'onboarding_tour_end_tour_body',
      null,
      null,
      false,
    ),
};

// Function return appropriate step data based on step name
export function getTourStepData(stepName: string): any {
  return Tour[stepName];
}

// Create step data object
function createStepMetaData(
  stepName: string,
  imageSource: string,
  bodyText: string,
  anchorLink: string,
  anchorText: string,
  showCarousel: boolean,
  additionalText?: string,
) {
  return {
    stepName, imageSource, bodyText, anchorLink, anchorText, showCarousel, additionalText,
  };
}
